import { WEATHER_BASE_URL } from '@/modules/weather/api'
import axios from 'axios'

export const getCapitalReq = (countryCode: string) => {
    return axios.post<any>(
        `https://countriesnow.space/api/v0.1/countries/capital`,
        { country: countryCode },
    )
}

export const getCapitalCoordnatesReq = (capitalName: string) => {
    return axios.get(
        `https://nominatim.openstreetmap.org/search?city=${capitalName}&format=json&limit=1`,
    )
}

export const getWeatherReq = (coordinate: string, lang: string) => {
    const apiKey = import.meta.env.VITE_WEATHER_API_KEY
    return axios.get(WEATHER_BASE_URL + '/current.json', {
        params: {
            key: apiKey,
            q: coordinate,
            lang,
        },
    })
}

export const geoCodePlaceReq = (coordinate: { lat: number; lng: number }) => {
    return axios.get(
        `https://nominatim.openstreetmap.org/reverse?format=json&lat=${coordinate.lat}&lon=${coordinate.lng}&accept-language=en`,
    )
}
